import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faArrowUpRightFromSquare,
  faBan,
  faBolt,
  faBookOpenCover,
  faBooks,
  faBoxArchive,
  faBoxOpen,
  faCalendarPlus,
  faChalkboardUser,
  faChartLineDown,
  faChartLineUp,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleDollar,
  faCircleInfo,
  faCircleNodes,
  faCircleQuestion,
  faCircleUser,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faComputer,
  faCopy,
  faCross,
  faDoorOpen,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faEye,
  faFileCertificate,
  faFileCheck,
  faFileExport,
  faFileImport,
  faFileLines,
  faFilePdf,
  faGauge,
  faHand,
  faHeadSideGoggles,
  faHelmetSafety,
  faHiking,
  faKey,
  faKeySkeleton,
  faLayerGroup,
  faLayerPlus,
  faLink,
  faList,
  faListCheck,
  faListTimeline,
  faLock,
  faLockKeyhole,
  faMagnifyingGlass,
  faMask,
  faMedal,
  faMoneyCheckDollarPen,
  faMountain,
  faPause,
  faPenToSquare,
  faPersonRunning,
  faPlay,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faRectangleList,
  faRotate,
  faScreencast,
  faScreenUsers,
  faSitemap,
  faSliders,
  faSwap,
  faTag,
  faTags,
  faThumbsDown,
  faThumbsUp,
  faTicket,
  faTimes,
  faTrashCan,
  faTriangleExclamation,
  faUpload,
  faUser,
  faUserGear,
  faUserHardHat,
  faUserHeadset,
  faUserLock,
  faUserPlus,
  faUsers,
  faUsersGear,
  faUserXmark,
  faVrCardboard,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

export function initRegularIcons() {
  library.add(
    faArrowLeft,
    faArrowRight,
    faArrowRotateLeft,
    faArrowUpRightFromSquare,
    faBan,
    faBolt,
    faBookOpenCover,
    faBooks,
    faBoxArchive,
    faBoxOpen,
    faCalendarPlus,
    faChalkboardUser,
    faChartLineDown,
    faChartLineUp,
    faChevronDown,
    faChevronRight,
    faCircle,
    faCircleCheck,
    faCircleDollar,
    faCircleInfo,
    faCircleNodes,
    faCircleQuestion,
    faCircleUser,
    faCircleXmark,
    faClipboardListCheck,
    faClock,
    faClockRotateLeft,
    faComputer,
    faCopy,
    faCross,
    faDoorOpen,
    faEdit,
    faEllipsisVertical,
    faEnvelope,
    faEye,
    faFileCertificate,
    faFileCheck,
    faFileExport,
    faFileImport,
    faFileLines,
    faFilePdf,
    faGauge,
    faHand,
    faHeadSideGoggles,
    faHelmetSafety,
    faHiking,
    faKey,
    faKeySkeleton,
    faLayerGroup,
    faLayerPlus,
    faLink,
    faList,
    faListCheck,
    faListTimeline,
    faLock,
    faLockKeyhole,
    faMagnifyingGlass,
    faMask,
    faMedal,
    faMoneyCheckDollarPen,
    faMountain,
    faPause,
    faPenToSquare,
    faPersonRunning,
    faPlay,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPrint,
    faQuestionCircle,
    faRectangleList,
    faRotate,
    faScreencast,
    faScreenUsers,
    faSitemap,
    faSliders,
    faSwap,
    faTag,
    faTags,
    faThumbsDown,
    faThumbsUp,
    faTicket,
    faTimes,
    faTrashCan,
    faTriangleExclamation,
    faUpload,
    faUser,
    faUserGear,
    faUserHardHat,
    faUserHeadset,
    faUserLock,
    faUserPlus,
    faUserXmark,
    faUsers,
    faUsersGear,
    faVrCardboard,
    faWandMagicSparkles,
    faXmark
  );
}
